<template>
  <div style="margin-bottom:20px">
    <a :href="$host + '/artists/' + artist.portfolio_url + ntlink"><img :src="$imagehost + '/' + artist.image_1" style="display:block" width="520" /></a>
    <div style="background-color:#ce0e2d;color:#ffffff;font-size:40px;padding:10px 5px">
      {{ artist.formatted_name}}
    </div>
    <div style="padding:17px 0 23px 0">
      <a style="display:inline-block;padding:5px 12px;color:#fff;text-decoration:none;background-color:#ce0e2d;border-radius:6px" 
          :href="$host + '/artists/' + artist.portfolio_url + ntlink">view {{ firstName }}'s portfolio</a>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    artist: Object
  },
  data() {
    return {
      cclink: this.$store.state.cclink + 'SPECIALISTS'
    }
  },
  computed: {
    firstName () {
      if(this.artist) {
        return this.artist.formatted_name.split(' ').slice(0, 1)[0]
      }
      return ''
    },
    ntlink () {
      let ntlink = this.cclink
      if(this.artist) {
        if(this.artist.formatted_name) {
          ntlink = this.cclink + '&utm_content=' + encodeURIComponent(this.artist.formatted_name)
        }
      }
      return ntlink
    }
  }
}
</script>

<style>

</style>